import { useMediaQuery } from "react-responsive";

//NOTE: If we change these, be sure to change tailwind.config.js to be the same.

const usePhoneMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 480px)" }, undefined, callback);
const useTabletMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 768px)" }, undefined, callback);
const useSmMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 1024px)" }, undefined, callback);
const useMdMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 1280px)" }, undefined, callback);
const useLgMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 1536px)" }, undefined, callback);
const useXlMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 1920px)" }, undefined, callback);
const use2xlMediaQuery = (callback?: (matches: boolean) => void) =>
  useMediaQuery({ query: "(max-width: 2560px)" }, undefined, callback);

export {
  usePhoneMediaQuery,
  useTabletMediaQuery,
  useSmMediaQuery,
  useMdMediaQuery,
  useLgMediaQuery,
  useXlMediaQuery,
  use2xlMediaQuery,
};
